module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "talent"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    达人管理\n    "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewTalent
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('el-select', {
    staticClass: "search-item",
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "达人Id",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "达人姓名",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "手机号",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "search-item-long",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "search-item-long",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择校区"
    },
    model: {
      value: (_vm.unid),
      callback: function($$v) {
        _vm.unid = $$v
      },
      expression: "unid"
    }
  }, _vm._l((_vm.zoneList), function(item) {
    return _c('el-option', {
      key: item.unid,
      attrs: {
        "value": item.unid,
        "label": item.name
      }
    })
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("发视频功能：")]), _vm._v(" "), _c('el-select', {
    staticClass: "search-item",
    model: {
      value: (_vm.videoEnable),
      callback: function($$v) {
        _vm.videoEnable = $$v
      },
      expression: "videoEnable"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已开通",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已关闭",
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("是否达人：")]), _vm._v(" "), _c('el-select', {
    staticClass: "search-item",
    model: {
      value: (_vm.enable),
      callback: function($$v) {
        _vm.enable = $$v
      },
      expression: "enable"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTalentList
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "talent-box"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.talentList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "talentId",
      "label": "达人ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phoneNumber",
      "label": "手机号",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zoneName",
      "label": "校区"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "className",
      "label": "院系"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dynamicNum",
      "label": "动态数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fansNum",
      "label": "粉丝"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "interestNum",
      "label": "关注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "praiseNum",
      "label": "获赞"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createUser",
      "label": "创建人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('el-button', {
            staticClass: "edit-btn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toTalentDetail(_vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.row.enable == 1) ? _c('el-button', {
            staticClass: "edit-btn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.openOrCloseTalent(_vm.row)
              }
            }
          }, [_vm._v("\n            再次开通")]) : _vm._e(), _vm._v(" "), (_vm.row.enable == 0) ? _c('el-button', {
            staticClass: "edit-btn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.openOrCloseTalent(_vm.row)
              }
            }
          }, [_vm._v("\n            取消达人")]) : _vm._e(), _vm._v(" "), (_vm.row.videoEnable == 0 && _vm.row.enable == 0) ? _c('el-button', {
            staticClass: "edit-btn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.openOrCloseVideo(_vm.row)
              }
            }
          }, [_vm._v("取消视频功能\n          ")]) : _vm._e(), _vm._v(" "), (_vm.row.videoEnable == 1 && _vm.row.enable == 0) ? _c('el-button', {
            staticClass: "edit-btn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.openOrCloseVideo(_vm.row)
              }
            }
          }, [_vm._v("开通视频功能\n          ")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNum,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.diaTitle,
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入原因说明"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendCancleReson
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f346b19!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/talent/talentManage.vue
// module id = 1043
// module chunks = 0